// NPM
import { graphql } from "gatsby"
import _ from "lodash"
import * as React from "react"

// Components
import Careers from "src/components/pages/Careers/Careers"
import Layout from "src/layouts/en"

const GenericProductPageEn = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, `careersPage.sections`, [])
  const jobPostings = _.get(data, `jobPostings.nodes`, [])
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.careersPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <Careers sections={sections} jobPostings={jobPostings} />
    </Layout>
  )
}

export default GenericProductPageEn

export const query = graphql`
  query CareersPageEnQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "en" }) {
      ...topNavContent
    }

    careersPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    jobPostings: allStrapiJobPosting(
      filter: { locale: { eq: "en" }, title: { ne: "__test" } }
    ) {
      nodes {
        ...jobPosting
      }
    }

    bottomNav: strapiBottomNav(locale: { eq: "en" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "en" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
